// @ts-check
/** Dashboard block registry: each block task adds its key to BLOCK_ORDER (display order) and its component here. */
import AtelierBlock from './AtelierBlock';
import ContactBlock from './ContactBlock';
import CustomersBlock from './CustomersBlock';
import ExpensesBlock from './ExpensesBlock';
import FunnelBlock from './FunnelBlock';
import InventoryBlock from './InventoryBlock';
import MarketingBlock from './MarketingBlock';
import OrdersBlock from './OrdersBlock';
import RecoveryBlock from './RecoveryBlock';
import PosBlock from './PosBlock';
import ReturnsBlock from './ReturnsBlock';
import ReviewsBlock from './ReviewsBlock';
import RevenueBlock from './RevenueBlock';
import SalesEventsBlock from './SalesEventsBlock';
import SeoBlock from './SeoBlock';
import ShipmentsBlock from './ShipmentsBlock';
import TasksBlock from './TasksBlock';
import TrafficRow from './TrafficRow';
import VendorsBlock from './VendorsBlock';
import WelcomeDiscountBlock from './WelcomeDiscountBlock';
import WhatsAppBlock from './WhatsAppBlock';
import WholesaleBlock from './WholesaleBlock';

/** @type {string[]} */
// Money first after traffic, then everything else.
export const BLOCK_ORDER = ['traffic', 'orders', 'revenue', 'pos', 'expenses', 'funnel', 'welcome_discount', 'inventory', 'shipments', 'returns', 'recovery', 'wholesale', 'customers', 'reviews', 'contact', 'whatsapp', 'marketing', 'seo', 'atelier', 'tasks', 'vendors', 'sales_events'];

/** @type {Record<string, import('react').ComponentType<{ block: object }>>} */
export const BLOCK_COMPONENTS = { traffic: TrafficRow, orders: OrdersBlock, funnel: FunnelBlock, welcome_discount: WelcomeDiscountBlock, inventory: InventoryBlock, shipments: ShipmentsBlock, returns: ReturnsBlock, recovery: RecoveryBlock, wholesale: WholesaleBlock, revenue: RevenueBlock, customers: CustomersBlock, reviews: ReviewsBlock, contact: ContactBlock, whatsapp: WhatsAppBlock, marketing: MarketingBlock, seo: SeoBlock, atelier: AtelierBlock, tasks: TasksBlock, expenses: ExpensesBlock, vendors: VendorsBlock, sales_events: SalesEventsBlock, pos: PosBlock };

/** Card titles by block key (falls back to the key). */
/** @type {Record<string, string>} */
export const BLOCK_TITLES = { traffic: 'Traffic', orders: 'Orders', funnel: 'Funnel', welcome_discount: 'Welcome discount', inventory: 'Inventory', shipments: 'Shipments', returns: 'Returns & exchanges', recovery: 'Recovery', wholesale: 'Wholesale', revenue: 'Revenue', customers: 'Customers', reviews: 'Reviews', contact: 'Contact messages', whatsapp: 'WhatsApp', marketing: 'Marketing', seo: 'SEO', atelier: 'Atelier', tasks: 'Tasks', expenses: 'Expenses', vendors: 'Vendors', sales_events: 'Sales events', pos: 'POS' };
